export const selectStyles = {
    menuPortal: (provided) => ({ ...provided, zIndex: 9999 }),
    container: (provided) => ({
        ...provided,
        fontFamily: "'Montserrat', sans-serif",
        boxShadow: 'none',
        // marginLeft:'6px',
        '&:hover': {
            borderColor: '#d3d4d8'
        },
        '&:focus': {
            borderColor: '#006d9e !important',
            boxShadow: 'none',
            outline: 0,
        }
    }),
    control: (provided) => ({
        ...provided,
        boxShadow: 'none',
        borderRadius: '8px',
        '&:hover': {
            borderColor: '#006d9e  !important',
            boxShadow: 'none',
            outline: 0,
        },
        '&:focus': {
            borderColor: '#006d9e  !important',
            boxShadow: 'none',
            outline: 0,
        },
        '&:visited': {
            borderColor: '#006d9e  !important',
        }
    }),
    placeholder: (provided) => ({
        ...provided,
        marginTop: '-2px',
        fontSize: '16px',
        fontFamily: "'Montserrat'",
        fontStyle: 'normal',
        fontWeight: 'normal',
        lineHeight: '150%',
        letterSpacing: '0.15px'
    }),
    dropdownIndicator: (provided) => ({
        ...provided,
        marginTop: '-6px'
    }),
    clearIndicator: (provided) => ({
        ...provided,
        marginTop: '-6px'
    }),
    indicatorSeparator: (provided) => ({
        ...provided,
        display: 'none'
    }),
    singleValue: (provided) => ({
        ...provided,
        fontWeight: "normal"
    }),
    menuList: (provided) => ({
        ...provided,
        fontWeight: 'normal'
    }),
    valueContainer: (provided) => ({
        ...provided,
        paddingTop: '2px',
        paddingBottom: '0px',
        paddingLeft: '8px',
    }),
    option: (provided, state) => ({
        ...provided,
        fontFamily: "'Montserrat', sans-serif",
        paddingTop: '1px',
        paddingBottom: '1px',
        backgroundColor: state.isFocused ? '#0D6EFD' : '#ffffff',
        color: state.isFocused ? '#ffffff' : '#222222',
        '&:hover': {
            backgroundColor: state.isFocused ? '#0D6EFD !important' : '#ffffff',
            color: state.isFocused ? '#ffffff' : '#222222',
            outline: 0,
        },
    }),
    input: (provided) => ({
        ...provided,
        "input:focus": {
            borderStyle: 'none !important',
        }
    })
};
